import React, { forwardRef } from 'react';
import Icon, { generateRenderedIcon } from './Icon';
import { VIEWBOXES } from '../consts';
const draw16px = 'M14.038,12.627l-.957-2.307c-.136-.329-.384-.364-.549-.077l-.51.882L9.5,10.132V2.791a.711.711,0,0,0-1.022-.64l-6.163,3a.714.714,0,0,0-.4.64v7.421a.713.713,0,0,0,.712.711.7.7,0,0,0,.3-.068l5.532-2.6L11.3,12.371l-.478.828c-.166.287-.012.483.342.437l2.476-.325a.474.474,0,0,0,.395-.684Zm-5.959-8.7V9.571L3.339,7.7V6.233Zm-4.74,8.16V9.233l3.3,1.3Z';
const draw24px = 'M20.84,14.845a.749.749,0,0,0-1.458.346l.641,2.7L12.454,13.9V3.188a.75.75,0,0,0-1.19-.608L2.337,9.034a.75.75,0,0,0-.311.608V20.5a.75.75,0,0,0,1.182.613l8.438-5.948,7.891,4.162-3.167.754a.75.75,0,0,0,.347,1.459L21.4,20.428a.749.749,0,0,0,.556-.9ZM3.526,19.056V10.885l6.631,3.5Zm7.428-5.95L4.2,9.541l6.759-4.885Z';
const icons = {
  _16: {
    d: draw16px,
    viewBox: VIEWBOXES._16
  },
  _24: {
    d: draw24px,
    viewBox: VIEWBOXES._24
  }
};
const AddXPlaneIcon = /*#__PURE__*/forwardRef(generateRenderedIcon(icons, 'addXPlane'));
AddXPlaneIcon.displayName = 'AddXPlaneIcon';
AddXPlaneIcon.propTypes = Icon.propTypes;
AddXPlaneIcon.renderIcon = props => /*#__PURE__*/React.createElement(AddXPlaneIcon, props);
export default AddXPlaneIcon;
//# sourceMappingURL=AddXPlaneIcon.js.map